import FetchClient from 'ha/helpers/FetchClient';
import createMakeCall from 'ha/services/apiV2/createMakeCall';

import getAllPayoutMethodRouting from './getAllPayoutMethodRouting';
import getBillingInformation from './getBillingInformation';
import getCommissionPlan from './getCommissionPlan';
import getPayoutMethod from './getPayoutMethod';
import getPayoutMethodRouting from './getPayoutMethodRouting';
import getPayoutTransactions from './getPayoutTransactions';
import patchUserPayoutMethods from './patchUserPayoutMethods';
import updateBillingInformation from './updateBillingInformation';
import updatePayoutMethodRouting from './updatePayoutMethodRouting';
import validateBillingInformation from './validateBillingInformation';

const createMoneta = (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    getAllPayoutMethodRouting: getAllPayoutMethodRouting(makeCall),
    getBillingInformation: getBillingInformation(makeCall),
    getCommissionPlan: getCommissionPlan(makeCall),
    getPayoutMethod: getPayoutMethod(makeCall),
    getPayoutMethodRouting: getPayoutMethodRouting(makeCall),
    getPayoutTransactions: getPayoutTransactions(makeCall),
    patchUserPayoutMethods: patchUserPayoutMethods(makeCall),
    updateBillingInformation: updateBillingInformation(makeCall),
    updatePayoutMethodRouting: updatePayoutMethodRouting(makeCall),
    validateBillingInformation: validateBillingInformation(makeCall),
  };
};

export default createMoneta;
